"use client";

import React from "react";
import { OakFlex, OakLink, OakSpan } from "@oaknational/oak-components";

import { GoogleSignInButtonIcon } from "./GoogleSignInButtonIcon";

type Props = {
  onClick?: () => void;
};
export const GoogleSignInButton: React.FC<Props> = (props) => {
  const [isHovered, setIsHovered] = React.useState<boolean>(false);
  return (
    <OakLink
      {...props}
      element="button"
      style={{
        textDecoration: "none",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label={"Sign in with Google"}
    >
      <OakFlex
        $pa={"spacing-16"}
        $width={"100%"}
        $gap={"spacing-12"}
        $alignItems={"center"}
        $justifyContent={"center"}
        $borderRadius={"border-radius-s"}
        $ba={"border-solid-s"}
        $borderColor={"border-neutral"}
        $background={isHovered && "grey20"}
      >
        <GoogleSignInButtonIcon />
        <OakSpan
          $font={"body-2-bold"}
          $color={"text-primary"}
          $hoverColor={"text-primary"}
        >
          Sign-in with Google
        </OakSpan>
      </OakFlex>
    </OakLink>
  );
};
